import getLang from 'LearningCenterUI/utils/getLang';
import { useLessonContentById } from '../lessons';
import { useTrack } from '../tracks';
export const useLearningContentType = ({
  lessonId,
  trackId,
  language,
  contentId
}) => {
  const content = useLessonContentById({
    lessonId: Number(lessonId),
    contentId: Number(contentId),
    language: language !== null && language !== void 0 ? language : getLang(),
    fetchPolicy: trackId ? 'cache-only' : 'cache-first'
  });
  const {
    track
  } = useTrack(Number(trackId), language !== null && language !== void 0 ? language : getLang(), !trackId);
  let type = 'CHAPTER';
  if (content) {
    type = content.contentType;
  } else if (track && track.introVideoId && Number(track.introVideoId) === Number(contentId)) {
    type = 'VIDEO';
  }
  return type;
};